export default {
    // 消息中间件资源类型查询接口
    listAuthTypeInfos(params, response) {
        window.vue.$apiAxios.get('/auth/role/getAllResType', params, response);
    },
    // 消息中间件资源类型查询接口
    listRoleResTypes(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/role/getAllRoleResType', params, response);
    },
    getMenuResTypeMap(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/role/getMenuResTypeMap', params, response);
    },
    // 消息中间件信息查询接口
    listRoleInfos(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/role/getRoleAuthList', params, response);
    },
    // 消息中间件信息查询接口
    listRoleResAuth(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/role/getCheckedAuth', params, response);
    },
    // 消息中间件删除接口
    deleteRoleInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/role/deleteRoleInfo', params, response);
    },
    // 消息添加接口
    insertRoleInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/role/insertRoleInfo', params, response);
    },
    // 消息更新接口
    updateRoleInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/role/updateRoleInfo', params, response);
    },
    // 消息更新接口
    getSysList(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/sys/getSysList', params, response);
    },
    // 获取菜单信息
    getMenuList(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/role/getMenuList', params, response);
    },
    // 查询选中菜单
    getCheckedRoleMenu(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/role/getCheckedRoleMenu', params, response);
    },
    // 获取菜单信息
    getOrgList(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/role/getOrgList', params, response);
    },
    // 查询选中菜单
    getCheckedRoleDept(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/role/getCheckedRoleDept', params, response);
    },
    // 查询选中菜单
    getRoleInfoByName(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/role/getRoleInfoByName', params, response);
    },
    // 查询树形显示的设备ID
    getDeviceTreeNodeID(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/getDeviceTreeNodeID', params, response);
    },
    // 查询时间表列表
    getAllTimeNoAndUUID(params, response) {
        window.vue.$apiAxios.postRequestBody('/access/getTimeNoAndUUIDByDataMarked', params, response);
    },
    // 消息中间件资源类型查询接口
    findOrgIds(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/role/findOrgIds', params, response);
    },
    //查询角色类型
    queryAllRoleType(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/roleType/queryAllRoleType', params, response);
    },
    //查询门禁设备
    queryDeviceOrgTreeByName(params, response) {
        window.vue.$apiAxios.postRequestBody('/device/queryDeviceOrgTreeByName', params, response);
    },
    //获取允许微调的资源类型
    getFinetuneResTypeList(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/res/getFinetuneResTypeList', params, response);
    },
    getRoleFinetuneInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auth/role/getRoleFinetuneInfo', params, response);
    },
    // 根据组标识获取值列表信息
    getDictValuesByTag(params, response) {
        window.vue.$apiAxios.get('/setting/dictController/getDictValuesByTag', params, response);
    }
};
